"use strict";
/*!
 * Copyright (C) 2019, NewFoundry, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

exports.__esModule = true;
exports.ValidationError = exports.TokenizerError = void 0;

var TokenizerError = function (_super) {
  __extends(TokenizerError, _super);

  function TokenizerError() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return TokenizerError;
}(Error);

exports.TokenizerError = TokenizerError;

var ValidationError = function (_super) {
  __extends(ValidationError, _super);

  function ValidationError() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ValidationError;
}(Error);

exports.ValidationError = ValidationError;